import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { launchPadLayoutActions } from "@sf-launchpad";

// Custom hook to change the change updates interval dynamically from Default(30s) to On Demand(1s) and vice versa
const useUpdatesInterval = (
  defaultInterval,
  onDemandInterval,
  onDemandDuration,
  updatesOnDemandInterval
) => {
  const [updatesInterval, setUpdatesInterval] = useState(
    defaultInterval * 1000
  );
  const dispatch = useDispatch();
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    // Change the updates interval to On Demand (1s) when the user exits the course player for the next minute
    if (updatesOnDemandInterval) {
      if (countdown === 0) {
        setCountdown(onDemandDuration);
        setUpdatesInterval(onDemandInterval * 1000);
      }
    } else {
      // Return the updates interval to Default(30s) when the user enters the course player
      // or a course completion is received while the countdown is running
      if (countdown > 0) {
        setCountdown(0);
      }
      setUpdatesInterval(defaultInterval * 1000);
    }
  }, [updatesOnDemandInterval, countdown]);

  useEffect(() => {
    // Return the updates interval to Default(30s) when the countdown is 0
    if (updatesOnDemandInterval && countdown === 0) {
      dispatch(
        launchPadLayoutActions.setState({ updatesOnDemandInterval: false })
      );
    } else {
      // Countdown from 60 seconds to return the updates interval to Default(30s)
      const interval = setInterval(() => {
        if (countdown > 0) {
          setCountdown(countdown - 1);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [countdown]);

  return updatesInterval;
};

export default useUpdatesInterval;
